export default __webpack_public_path__ + "static/media/fontRoboto900_cyrillic_ext.45cc87e0.woff2";